import styled, { css } from "styled-components/macro"
import { Card, Collapsible, Icon, IconButton } from "@humanpredictiveintelligence/myqvt-library"

export const ChoosenQuestionListContainer = styled.div`
  width: 50%;
`

export const Question = {
  Choice: styled.div`
    margin: 8px 0;
  `,
  Choices: styled(Collapsible)`
    margin-bottom: 16px;
  `,
  DragHandle: styled(Icon)`
    cursor: pointer;
  `,
  Label: styled.div`
    ${({ theme: { colors, typography, sizes } }) => css`
      background-color: ${colors.primaryLight};
      border-radius: ${sizes.borderRadiusRounded};
      padding: 10px 8px;
      color: ${colors.blackMedium};
      font-size: ${typography.fontSizeLabelMedium};
      text-transform: uppercase;
      font-weight: ${typography.fontWeightMedium};
    `}
  `,
  LabelAndHandel: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  Name: styled.div`
    font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  `,
  NameAndChoices: styled.div`
    flex: 1;
    width: 100%;
  `,
  RemoveAction: styled(IconButton)`
    align-self: flex-start;
  `,
}

export const Container = styled(Card)`
  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: visible;
`

export const SectionTitle = styled.div`
  padding: 12px 24px;
`

export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 12px 24px;
  gap: 10px;
`

export const EmptyList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`
